
import {
    defineComponent,
    computed,
    onMounted,
    ref
} from "vue";
import {
    useI18n
} from "vue-i18n/index";
import {
    useStore
} from "vuex";
import {
    useRouter
} from "vue-router";
import {
    Actions
} from "@/store/enums/StoreEnums";
import {
    config
} from "@/core/helpers/config";

export default defineComponent({
    name: "kt-user-menu",
    components: {},
    setup() {
        const terms = ref(process.env.VUE_APP_TERMS)
        const router = useRouter();
        const i18n = useI18n();
        const {
            t
        } = useI18n();
        const store = useStore();

        i18n.locale.value = localStorage.getItem("lang") ?
            (localStorage.getItem("lang") as string) :
            "es";

        const countries = {
            en: {
                flag: "media/flags/united-states.svg",
                name: "English",
                id: "en",
            },
            es: {
                flag: "media/flags/spain.svg",
                name: "Spanish",
                id: "es",
            },
            /*de: {
                flag: "media/flags/germany.svg",
                name: "German",
                id: "de",
            },
            ja: {
                flag: "media/flags/japan.svg",
                name: "Japanese",
                id: "ja",
            },
            fr: {
                flag: "media/flags/france.svg",
                name: "French",
                id: "fr",
            },
            */
        };

        const signOut = () => {
            //config.value.aside.display = false
            //localStorage.setItem("config", JSON.stringify(config.value));
            store.dispatch(Actions.LOGOUT).then(() =>
                router.push({
                    name: "sign-in",
                })
            );
        };

        const setLang = (lang) => {
            localStorage.setItem("lang", lang);
            i18n.locale.value = lang;
            window.location.reload(); // Refrescar el navegador
        };

        const currentLanguage = (lang) => {
            return i18n.locale.value === lang;
        };

        const currentLangugeLocale = computed(() => {
            return countries[i18n.locale.value];
        });

        const username: any = computed < any > (() => {
            return store.getters.currentUser.account;
        });

        onMounted(() => {
            //person.value = username.firstname
        });

        return {
            config,
            signOut,
            setLang,
            currentLanguage,
            currentLangugeLocale,
            countries,
            username,
            terms,
            t,
        };
    },
});
